import _get from 'lodash/get'
import { delay as wait, fromCallback as fromCallbackPromise } from 'bluebird'
import { getExponentialDelay } from 'exponential-backoff'
import { get as getConfig } from 'config'

const config = getConfig()
const defaultOfferId = _get(config, ['everflow', 'defaultOfferId'])
// eslint-disable-next-line prefer-destructuring
const BROWSER = process.env.BROWSER

export const EVERFLOW_OFFER_ID_DEFAULT = defaultOfferId

export async function getEverFlowScript (attempt = 0, maxAttempt = 3) {
  // bail if EverFlow SDK already exists
  if (!BROWSER || global.EF) {
    return
  }
  try {
    const { default: scriptjs } = await import('scriptjs')
    await fromCallbackPromise((cb) => scriptjs('https://www.gja4trk.com/scripts/sdk/everflow.js', () => cb()))
  } catch (e) {
    const { EF } = global
    // Check if EverFlow SDK did load and try again
    /* eslint-disable no-useless-return */
    if (!EF && attempt < maxAttempt) {
      // Try to load the script again
      await wait(getExponentialDelay(attempt, 300))
      await getEverFlowScript(attempt + 1, maxAttempt)
      return
    }

    if (!EF && attempt === maxAttempt) {
      // We tried too many times and the script didn't load, just give up
      return
    }
  }
}
